module.exports = __webpack_public_path__ + "static/toast-casepuctuation-do-7b0f8f2270bc7bb31327b2c3540d5759.png";